import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Progress, Space, Spin, Table, Tag, Typography } from 'antd';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import { ArrayParam, useQueryParam } from 'use-query-params';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import { Team } from '../../../../entity/Team';
import { Employee } from '../../../../entity/Employee';
import { useHistory } from 'react-router-dom';
import Link from 'antd/lib/typography/Link';
import { PageHeader } from '@ant-design/pro-layout';

const { Text } = Typography;

interface GetTeam extends Team {
  goalSummary: any;
}

interface GetEmploy extends Employee {
  goalSummary: any;
}

const setDetails = (keyResults: []) => {
  let newStatus: string;
  let test1 = keyResults?.findIndex((item: any) => item.status === 'On-hold');
  if (test1 === -1) {
    test1 = keyResults?.findIndex((item: any) => item.status === 'Offtrack');
    if (test1 === -1) {
      test1 = keyResults?.findIndex((item: any) => item.status === 'Ontrack');
      if (test1 === -1) {
        test1 = keyResults?.findIndex((item: any) => item.status === 'Not Started');
        if (test1 === -1) {
          test1 = keyResults?.findIndex((item: any) => item.status === 'Pending');
          if (test1 === -1) {
            newStatus = 'Completed';
          } else {
            newStatus = 'Pending';
          }
        } else {
          newStatus = 'Not Started';
        }
      } else {
        newStatus = 'Ontrack';
      }
    } else {
      newStatus = 'Offtrack';
    }
  } else {
    newStatus = 'On-hold';
  }
  return newStatus;
};

const setDetails1 = (keyResults: []) => {
  const sum = keyResults
    ?.map((item: any) =>
      item.goals
        ?.map((item: any) => item.completed * +item.weight)
        .reduce((a: number, b: number) => a + b, 0),
    )
    .reduce((a: number, b: number) => a + b, 0);
  return sum !== 0
    ? sum /
        keyResults
          ?.map((item: any) =>
            item.goals?.map((item: any) => +item.weight).reduce((a: number, b: number) => a + b, 0),
          )
          .reduce((a: number, b: number) => a + b, 0)
    : 0;
};

const setDetails2 = (keyResults: []) => {
  const sum = keyResults
    ?.map((item: any) =>
      item.goals
        ?.map(
          (item: any) =>
            item.completed *
            (isNaN(item?.teamWeight ?? item.weight ?? 0)
              ? 0
              : +(item?.teamWeight ?? item.weight ?? 0)),
        )
        .reduce((a: number, b: number) => a + b, 0),
    )
    .reduce((a: number, b: number) => a + b, 0);
  return sum !== 0
    ? sum /
        keyResults
          ?.map((item: any) =>
            item.goals
              ?.map((item: any) =>
                isNaN(item?.teamWeight ?? item.weight ?? 0)
                  ? 0
                  : +(item?.teamWeight ?? item.weight ?? 0),
              )
              .reduce((a: number, b: number) => a + b, 0),
          )
          .reduce((a: number, b: number) => a + b, 0)
    : 0;
};

export const MyGoals: FC = () => {
  const [cycle, setCycle] = useQueryParam<number | undefined>('cycle');
  const [expanded, setExpanded] = useQueryParam('e', ArrayParam);
  const cycleRef = useRef(cycle);
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const user = useUserInfo();
  const history = useHistory();

  const columns = useMemo(() => {
    return [
      {
        title: 'Objectives',
        dataIndex: 'title',
        key: 'title',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) =>
          record.itemType ? (
            <div>
              {/*<Tooltip placement="top" title={`Go to ${text} Objectives`}>*/}
              <Space>
                <UserAvatar type={record.itemType} src={record.image} />
                <Link
                  onClick={() => {
                    if (record.link) history.push(record.link);
                  }}>
                  {text}
                </Link>
              </Space>
              {/*</Tooltip>*/}
            </div>
          ) : (
            <Text strong>{text}</Text>
          ),
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: '150px',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) =>
          record.type ? <Tag color={record.color}>{text}</Tag> : '',
      },
      {
        title: 'Progress',
        dataIndex: 'completed',
        key: 'completed',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) =>
          record?.completed == undefined ? (
            <></>
          ) : (
            <>
              {/*{record?.status}*/}
              <Progress
                percent={Math.round(record?.completed * 100 ?? 0) / 100}
                strokeColor={
                  record?.status === 'Completed'
                    ? 'green'
                    : record?.status === 'Offtrack'
                    ? 'red'
                    : record?.status === 'Pending'
                    ? '#096dd9'
                    : record?.status === 'Ontrack'
                    ? '#f4d03f'
                    : '#000000'
                }
              />
            </>
          ),
        width: '250px',
      },
    ];
  }, [history]);

  const [data, setData] = useState<{
    memberTeams: GetTeam[];
    leadingTeams: GetTeam[];
    parentTeams: GetTeam[];
    supervisingTeams: GetTeam[];
    supervisingUsers: GetEmploy[];
    supervisingTeamMembers: any[];
    personalGoalHolderId: number;
    goalSummaryStatus: string;
    goalSummaryCompleted: number;
    goalsAvailability: boolean;
  }>();
  const [loading, setLoading] = useState<boolean>(false);

  const connection = useConnection();
  useEffect(() => {
    setLoading(true);
    const token = connection.hasSession();
    if (token) {
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle(value.closestCycle.id, 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    if (cycles.length === 0 || !cycle) {
      return;
    }
    setLoading(true);
    const token = connection.hasSession();
    if (token) {
      connection
        .get(`users/${user?.userId}/${cycle ?? 1}/goal-selection`)
        .then(setData)
        .finally(() => setLoading(false));
    }
  }, [connection, cycle, cycles.length, user?.userId]);

  const tableData = useMemo(() => {
    if (!data) {
      return [];
    }
    const userdata = (t: any) => ({
      image: t.image,
      title: t.name,
      link: `/webux/my-goals/goals/user/${t.id}/${encodeURIComponent(t.name)}/${
        t.oid
      }?cycle=${cycle}`,
      key: t.id,
      type: 'Employee',
      color: 'geekblue',
      itemType: 'user',
      status: setDetails(t.goalSummary) ?? 'Pending',
      completed: setDetails1(t.goalSummary) ?? 0,
    });
    const userdata2 = (t: any, i: number) => ({
      image: t.image,
      title: t.name,
      link: `/webux/my-goals/goals/user/${t.id}/${encodeURIComponent(t.name)}/${
        t.oid
      }?cycle=${cycle}`,
      key: t.id + i * 100,
      type: 'Employee',
      color: 'geekblue',
      itemType: 'user',
      status: setDetails(t.goalSummary) ?? 'Pending',
      completed: setDetails1(t.goalSummary) ?? 0,
    });
    const teamdata = (t: any) => ({
      image: t.image,
      title: t.name,
      link: `/webux/my-goals/goals/team/${t.id}/${encodeURIComponent(t.name)}/${
        t.oid
      }?cycle=${cycle}`,
      key: t.id,
      type: t.teamType.name,
      color: t.teamType.color,
      itemType: 'team',
      status: setDetails(t.goalSummary) ?? 'Pending',
      completed: setDetails2(t.goalSummary) ?? 0,
    });
    let teams = [
      ...data.memberTeams.map(teamdata),
      ...data.leadingTeams.map(teamdata),
      ...data.supervisingTeams.map(teamdata),
      ...data.parentTeams.map(teamdata),
    ];
    let types = [
      ...data.memberTeams.map((e) => e.teamType.name),
      ...data.leadingTeams.map((e) => e.teamType.name),
      ...data.supervisingTeams.map((e) => e.teamType.name),
      ...data.parentTeams.map((e) => e.teamType.name),
    ];
    types = types.filter((item, pos) => {
      return types.indexOf(item) == pos;
    });
    teams = teams.filter(
      (team, index, self) =>
        index === self.findIndex((t) => t.title === team.title && t.link === team.link),
    );
    const supervisingUsers = data.supervisingUsers.filter(
      (user, index, self) => index === self.findIndex((t) => t.id === user.id),
    );

    const supervisingMembersTeam = data.supervisingTeamMembers
      .map((e) => ({ id: e.teamId, name: e.teamName }))
      .filter((team, index, self) => index === self.findIndex((t) => t.id === team.id))
      .map((e) => ({
        id: e.id,
        name: e.name,
        users: data.supervisingTeamMembers.filter((e1) => e1.teamId === e.id),
      }));

    const tdt: any = [];
    if (data.goalsAvailability) {
      tdt.push({
        key: -4,
        title: `My Objectives`,
        link: '#',
        children: [
          {
            image: user?.image,
            title: user?.fullName,
            link: `/webux/my-goals/goals/user/${data?.personalGoalHolderId}/${encodeURIComponent(
              user?.fullName ?? '',
            )}/${user?.userId}?cycle=${cycle}`,
            key: -4,
            type: 'Self',
            color: 'gold',
            itemType: 'user',
            status: data?.goalSummaryStatus ?? 'Pending',
            completed: data?.goalSummaryCompleted ?? 0,
          },
        ],
      });
    }
    let i = -7;
    types.forEach((e) => {
      tdt.push({
        key: i--,
        title: `${e} Objectives`,
        link: '#',
        children: teams.filter((e1) => e1.type === e),
      });
    });
    if (supervisingUsers.length !== 0) {
      tdt.push({
        key: -3,
        title: `Subordinates' Objectives`,
        link: '#',
        children: supervisingUsers.sort((a, b) => a.id - b.id).map(userdata),
      });
    }

    if (supervisingMembersTeam.length !== 0) {
      tdt.push({
        key: -2,
        title: `Subordinates' Team Members Objectives`,
        link: '#',
        children: supervisingMembersTeam.map((e) => ({
          key: e.id * 1000,
          title: e.name,
          link: '#',
          children: e.users.map((e1) => userdata2(e1, e.id * 1000)),
        })),
      });
    }
    return tdt;
  }, [cycle, data, user?.fullName, user?.image, user?.userId]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title="Objectives"
        subTitle="Manage objectives"
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            <CycleToggle
              value={parseInt(`${cycle}`)}
              onChange={(value) => setCycle(value, 'replace')}
              data={cycles}
            />
          </FlexBox>
          <Spin spinning={loading}>
            <Table
              size="small"
              columns={columns}
              dataSource={tableData}
              expandable={{ indentSize: 30 }}
              expandedRowKeys={
                expanded
                  ? (expanded as any)
                      .map((x: any) => parseInt(x, 10))
                      .filter((f: number) => f !== -5)
                  : [-1, -2, -3, -4, -6, -7, -8, -9, -10, -11, -12, -13, -14, -15]
              }
              onExpandedRowsChange={(expanded: any) => {
                setExpanded(expanded.length === 0 ? -5 : expanded, 'replaceIn');
              }}
              pagination={false}
            />
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
